module.exports = __webpack_public_path__ + "img/dept-6.2567924c.svg";